import { createFileRoute } from "@tanstack/react-router";

import { adminSearchSchema } from "@/api/contracts/admin-tabs";
import { AdminPage } from "@/components/admin/AdminPage";
import { requireAdminSectionAccess } from "@/lib/route-guards";

// The Admin section. One route for the whole section: its tabs are a search
// param, not a subtree, which is both the old stack's URL shape and what keeps
// adding a tab down to an entry in the inventory (see admin-tabs.ts).
//
// The `_authed` layout has already guaranteed a session; this gate narrows that
// to a session that can administrate. It is a door, not the enforcement —
// Python use cases remain that (#67 §4) — so nothing behind it may rely on
// having passed here.
export const Route = createFileRoute("/_authed/_chrome/admin")({
  // Zod v4 implements Standard Schema, so the schema passes in directly.
  validateSearch: adminSearchSchema,
  beforeLoad: ({ context }) => {
    requireAdminSectionAccess(context.currentUser);
  },
  head: () => ({ meta: [{ title: "Admin" }] }),
  component: AdminSection,
});

function AdminSection() {
  // The whole parsed search object, not just `tab`: the tabs carry params of
  // their own now (the Item Catalog tab's `?catalog=`), and the shell is where
  // each tab's panel picks the ones it needs. It also applies the fallbacks —
  // a bare `/admin`, or a param the schema dropped, opens the first tab and
  // the first sub-tab, the way the old page resolved an unknown slug.
  return <AdminPage search={Route.useSearch()} />;
}
